import { render, staticRenderFns } from "./data-protection.vue?vue&type=template&id=c0ff6068&scoped=true"
import script from "./data-protection.vue?vue&type=script&lang=js"
export * from "./data-protection.vue?vue&type=script&lang=js"
import style0 from "./data-protection.vue?vue&type=style&index=0&id=c0ff6068&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ff6068",
  null
  
)

export default component.exports